
export class FilesUploadDto {
  files: any[];
}
